<template>
  <div>
    <vue-header></vue-header>
    <router-view></router-view>
    <vue-footer></vue-footer>
    <div id="support">
      <support></support>
    </div>
  </div>
</template>
<script>
  import helper from "../mixins/helper.js";
  import error from "../mixins/error.js";
  import footer from "./layouts/footer";
  import header from "./layouts/header";
  import loginReg from "./modals/login-registarion";
  import alertMessage from "./modals/messages/alert-message";
  import forgetPassword from "./modals/forgetPassword/forget";
  import newPassword from "./modals/forgetPassword/newPassord";
  import Payment from "./modals/Payment";
  import CvDownload from "./modals/cv-download";
  import openShareModal from "./modals/open-share-modal";
  import Cookies from "js-cookie";
  import templates from "./modals/Templates";

  import modalBuy from "./modals/buyTariff/modalBuy";
  import modalBuyLoad from "./modals/buyTariff/modalBuyLoad";
  import modalLoader from "./modals/loader";

  import support from './support/SupportComponent';

  import config from "../config.js";
  import Seo from "../mixins/seo";
  import "vue-slider-component/theme/antd.css";

  export default {
    components: {
      "vue-footer": footer,
      "vue-header": header,
      "login-reg": loginReg,
      "alert-message": alertMessage,
      "forget-password": forgetPassword,
      "new-password": newPassword,
      templates,
      Payment,
      CvDownload,
      openShareModal,

      modalBuy,
      modalBuyLoad,

      modalLoader,

      support
    },
    mixins: [helper, error, Seo],
    data() {
      return {
        isActive: false,
        toggle: false,
        lang: this.$store.getters.locale
      };
    },
    watch: {
      $route(to, from) {
        if (config.seo[to.name]) {
          this.setSeo(
            config.seo[to.name][to.params.lang]["title"] || "",
            config.seo[to.name][to.params.lang]["description"] || ""
          );
        }
        if (to.params.lang != from.params.lang) {
          this.$store.commit("translate", this.checkLocale(to.params.lang));
          this.$store.commit("locale", this.getLocale(this.$route.params.lang));
        } else if (to.path !== from.path) {
          this.$scrollTo("body");
        }
        if (this.$store.getters.cvDownload.show) {
          this.$store.commit("cvDownload");
        }
      }
    },
    mounted() {
      if (this.$route.params.lang === undefined) {
        this.$route.params.lang = Cookies.get("locale") || "ru";
      }

      this.setSeo(
        config.seo[this.$route.name] ? config.seo[this.$route.name][this.$route.params.lang]["title"] : config.seo['profile'][this.$route.params.lang]["title"],
        config.seo[this.$route.name] ? config.seo[this.$route.name][this.$route.params.lang]["description"] : config.seo['profile'][this.$route.params.lang]["description"]
      );
      this.$store.commit("translate", this.checkLocale(this.$route.params.lang));
      if (this.$route.query.locale) {
        this.$store.commit("locale", this.getLocale(this.$route.query.locale));
      } else {
        this.$store.commit("locale", this.getLocale(this.$route.params.lang));
      }
      /* handleErrors bolor errorner@ uxarkum enq error mixin */
      var vm = this;
      this.$http.interceptors.response.use(
        function (response) {
          return response;
        },
        function (error) {
          if (error.response) {
            NProgress.done();
            vm.handleErrors(error);
            return Promise.reject(error);
          }
        }
      );
      /* end */
    },
    methods: {
      openLoginModal(status) {
        this.loginModal = status;
      },
      getLocale(locale) {
        if (locale !== this.$Cookies.get("locale")) {
          this.$Cookies.set("locale", locale, {expires: 3});
        }
        return this.$Cookies.get("locale");
      },

      getData() {
        return new Promise((reslove, reject) => {
          if (!this.$store.getters.languages.length) {
            this.$http({
              method: "get",
              url: `/api/main-page/`
            }).then(res => {
              this.$store.commit("languages", res.data.site_languages);
              this.$store.commit("user", res.data.user);
              this.$store.commit("tariffs", res.data.tariffs);
              this.$store.commit("tariffsArray", res.data.tariffsArray);
              reslove(true);
            });
          } else {
            reslove(true);
          }
        });
      },
      forgetPassword(token) {
        this.$http({
          method: "post",
          url: `/api/forget-password/${token}`
        }).then(res => {
          if (res.data.invalid) {
            this.$store.commit("newMessage", {
              show: true,
              type: "error",
              messageTitle: this.$store.getters.t("error"),
              message: this.$store.getters.t("invalid token please try now")
            });
            this.$router.push("home");
          } else if (res.data.timeout) {
            this.$store.commit("newMessage", {
              show: true,
              type: this.$store.getters.t("attention"),
              messageTitle: this.$store.getters.t("timeout"),
              message: this.$store.getters.t("token time ended")
            });
            this.$router.push("home");
          } else if (res.data.token) {
            this.$store.state.forgetEmail = res.data.email;
            this.$store.commit("newPassword", true);
          }
        });
      }
    }
  };
</script>




// WEBPACK FOOTER //
// resources/js/components/AppContent.vue